import { AppThunk } from "../../models/app-thunk";
import * as types from "../../constants";
import { SNACK_DURATION } from "../../constants";
import { SnackState } from "../../models/snack-state";

export const openSnack = (text: string, state: SnackState): AppThunk => {
  return (dispatch) => {
    dispatch({
      type: types.UI_SNACK_OPEN,
      payload: true,
    });
    dispatch({
      type: types.UI_SNACK_STATE_CHANGE,
      payload: state,
    });
    dispatch({
      type: types.UI_SNACK_TEXT_CHANGE,
      payload: text,
    });

    const timeoutId = setTimeout(() => {
      dispatch({
        type: types.UI_SNACK_STATE_CHANGE,
        payload: SnackState.INITIAL,
      });
      clearTimeout(timeoutId);
    }, SNACK_DURATION + 500);
  };
};

export const openSnackLogin = (text: string, state: SnackState): AppThunk => {
  return (dispatch) => {
    dispatch({
      type: types.UI_SNACK_OPEN_LOGIN,
      payload: true,
    });
    dispatch({
      type: types.UI_SNACK_STATE_CHANGE_LOGIN,
      payload: state,
    });
    dispatch({
      type: types.UI_SNACK_TEXT_CHANGE_LOGIN,
      payload: text,
    });

    const timeoutId = setTimeout(() => {
      dispatch({
        type: types.UI_SNACK_STATE_CHANGE_LOGIN,
        payload: SnackState.INITIAL,
      });
      clearTimeout(timeoutId);
    }, SNACK_DURATION + 500);
  };
};

export const closeSnack = () => ({
  type: types.UI_SNACK_OPEN,
  payload: false,
});
